import React from "react";

/**
 * Wordmark de la plataforma: solo el texto "Datos para la Democracia", sin el
 * isotipo, igual que en el footer. El isotipo queda reservado para el favicon,
 * donde sí funciona a tamaño chico.
 * variant="light" usa el wordmark en blanco, para fondos oscuros.
 */
export default function BrandMark({ height = 40, variant = "dark" }) {
  const src = variant === "light" ? "/img/logo-texto-claro.png" : "/img/logo-texto.png";
  return (
    <img
      src={src}
      alt="Datos para la Democracia"
      height={height}
      style={{ display: "block", width: "auto", flexShrink: 0, objectFit: "contain" }}
    />
  );
}
